import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography } from "antd";
import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard_i = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar1, _dataBar1] = useState();
  const [dataBar2, _dataBar2] = useState();

  useEffect(() => {
    Find_barData("bar1");
    Find_barData("bar2");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db3_I", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            if (order == "bar1") {
              Tb1.push({
                name: i.name,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar1") {
          _dataBar1(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    let currentYear = new Date().getFullYear();
    let Tb2 = [];

    if (order == "bar2") {
      for (let i = 4; i >= 0; i--) {
        // console.log(currentYear  - i);
        let zyear = currentYear - i;
        let zdata = 0;
        if (zyear == 2023 || zyear == 2024 || zyear == 2025) {
          zdata = 75;
        }

        Tb2.push({
          name: zyear,
          zcount: zdata
        });
      }
    }

    if (order == "bar2") {
      _dataBar2(Tb2);
    }
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          Internationalized and Impactful Education
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #fdc4c4ff"
            }}
            title="[KR5] ร้อยละผลงานตีพิมพ์ของนักศึกษาที่อยู่ใน Q1 ของฐานข้อมูล
              Scopus"
          >
            <Barchart dataBar={dataBar1} order={"I1"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #fdc4c4ff"
            }}
            title="[KR6] ร้อยละของนักศึกษาที่เรียนจบตามกำหนดเวลา"
          >
            <Barchart dataBar={dataBar2} order={"I2"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      <div style={{ height: "300px" }} />
    </React.Fragment>
  );
};

export default Dashboard_i;
